import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext, Dots } from '../../../components/ui/carousel'
import { ReviewCard } from './partials/review-card'
import { Review } from '../data'
import { useReviewsConfig } from '../providers'

export function ReviewsCarousel({ reviews }: { reviews: Review[] }) {
  const options = useReviewsConfig()

  return (
    <div className="homerunner-reviews-carousel w-full">
      <div className="homerunner-reviews-carousel-container relative">
        <Carousel className="homerunner-reviews-carousel-inner w-full">
          {!options.carousel?.hideArrows && (
            <CarouselPrevious className="homerunner-reviews-carousel-prev absolute start-0 top-1/2 -translate-y-1/2 z-10 bg-muted-foreground/70 hover:bg-muted-foreground/90 text-primary-foreground rounded-full w-10 h-10 flex items-center justify-center shadow-lg border-none" />
          )}
          <CarouselContent className="homerunner-reviews-carousel-content">
            {reviews.map((review) => (
              <CarouselItem
                key={review.id}
                className="homerunner-reviews-carousel-item basis-full sm:basis-1/2 lg:basis-1/4 px-2"
              >
                <ReviewCard review={review} />
              </CarouselItem>
            ))}
          </CarouselContent>
          {!options.carousel?.hideArrows && (
            <CarouselNext className="homerunner-reviews-carousel-next absolute end-0 top-1/2 -translate-y-1/2 z-10 bg-muted-foreground/70 hover:bg-muted-foreground/90 text-primary-foreground rounded-full w-10 h-10 flex items-center justify-center shadow-lg border-none" />
          )}
          {!options.carousel?.hideDots && (
            <div className="homerunner-reviews-carousel-dots">
              <Dots />
            </div>
          )}
        </Carousel>
      </div>
    </div>
  )
}
